import Firebase, { withEnvParam } from "#classes/Firebase"

/**
 * fetch() wrapper for server /api/* routes. Attaches the manager's Firebase
 * ID token as a Bearer header — the server rejects /api/* requests without
 * one (see server/serverAuthMiddleware.ts). Falls back to an unauthenticated
 * request if no one is signed in, so the server's 401 (rather than a client
 * throw) is what surfaces to the caller.
 */
export const authedFetch = async (
  url: string,
  options: RequestInit = {}
): Promise<Response> => {
  const token = await Firebase.getInstance().getIdToken()
  const headers = new Headers(options.headers)
  if (token) {
    headers.set("Authorization", `Bearer ${token}`)
  }
  return fetch(withEnvParam(url), { ...options, headers })
}
